<mat-toolbar class="header-content">
    <div class="header-title">
        <mat-icon>visibility</mat-icon>
        {{ 'trackers.view_settings_title' | translate }}
    </div>

    <lib-button icon="close" color="none" textColor="muted" (click)="close()"
        tooltip="{{'viewer.close'|translate}}"></lib-button>
</mat-toolbar>

<mat-dialog-content>
    <div class="tracker-card" *ngFor="let tracker of visibleTrackers">
        <div class="tracker-card-header">
            <span class="tracker-name">{{ tracker.name }}</span>
            <span class="type-chip">{{ tracker.type }}</span>
        </div>

        <table class="settings-table" *ngIf="settingsEntries(tracker).length">
            <tr *ngFor="let entry of settingsEntries(tracker)">
                <td class="settings-key">{{ entry.key }}</td>
                <td class="settings-value">{{ entry.value }}</td>
            </tr>
        </table>

        <p class="no-settings" *ngIf="!settingsEntries(tracker).length">{{'trackers.no_settings'|translate}}</p>
    </div>
</mat-dialog-content>
